module.exports = __webpack_public_path__ + "img/Differentiation-SCC_GSE144240.d1c06ede.png";